/**
 * Dark shell tokens for Dashboard 409A / workboard (ThemeProvider `darkTheme`).
 * Light mode is unchanged — consume these values from `darkTheme` palette or here when branching on `theme.palette.mode === 'dark'`.
 *
 * Layering: L0 canvas (main) → left rail + tab bar + paper share elevated grays vs canvas.
 */
export const DASHBOARD_DARK = {
  /** L0 — main app canvas (área de contenido a la derecha del drawer) */
  canvas: '#131316',
  /**
   * Left icon rail — mismo nivel que `surface` / barra de pestañas: se nota como franja frente al canvas.
   * (Antes más oscuro; quedaba como un “agujero” negro.)
   */
  sidebar: '#18181D',
  /** L1 — cards, table well, sticky headers, horizontal tab bar */
  surface: '#18181D',
  /** Row / control hover on surface */
  surfaceHover: '#1F1F26',
  /** Hairlines — separators, sidebar edge (no harsh grids) */
  hairline: 'rgba(255, 255, 255, 0.06)',
  /** Same as SCSS `$tableBodyCellBorderDark` — table row borders, column resize grip */
  tableBodyCellBorderDark: '#2d2d2d',
  textPrimary: '#ECECEF',
  /** Brighter than typical zinc-400 so inactive labels / sidebar icons read on charcoal */
  textSecondary: '#B8BCC8',
  textDisabled: '#71717A',
  /** Accent tint for active nav rows — do NOT use as `palette.action.active` (MUI icons need light gray/white) */
  accentTint: 'rgba(79, 140, 255, 0.14)',

  // ─── Accent color system (dark mode only) ────────────────────────────────────
  // Base: #4F8CFF — softer perceptual blue, lower chroma than #037de8.
  // Works on dark surfaces because it sits at ~55% lightness (not 50%), so it
  // reads clearly without the "neon" harshness of fully-saturated primaries.
  accent: '#4F8CFF',          // primary buttons, active states, links
  accentHover: '#6B9FFF',     // slightly lighter — hover on buttons / icons
  accentActive: '#3A78F0',    // slightly darker — pressed state
  accentSoft: 'rgba(79, 140, 255, 0.12)',   // tinted row bg, chip fill
  accentBorder: 'rgba(79, 140, 255, 0.30)', // outline buttons, input focus ring
} as const;
